var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Refresh_Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Refresh_Icon",
    "data-name": "Refresh Icon",
    clipPath: "url(#clip-Refresh_Icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-refresh-cw",
    "data-name": "Icon feather-refresh-cw",
    transform: "translate(30.289 2.758) rotate(93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M32,6v6.5H25.5",
    transform: "translate(-6.669 -0.416)",
    fill: "none",
    stroke: "#8bc500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M1.5,27.5V21H8",
    transform: "translate(0 -4.584)",
    fill: "none",
    stroke: "#8bc500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M4.219,11A9.749,9.749,0,0,1,20.3,7.361l5.026,4.723M1.5,16.416l5.026,4.723A9.749,9.749,0,0,0,22.612,17.5",
    fill: "none",
    stroke: "#8bc500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.faf89c8ca076a81bb201d5ff224632bc.svg";
export { ForwardRef as ReactComponent };